module.exports = __webpack_public_path__ + "img/ico_menual02_off.6af69dc5.svg";